import { useEffect, useState, useCallback } from 'react';
import copy from 'copy-to-clipboard';

type CopyableValue = string | number;

const useCopyToClipboard = (
    resetInterval: number | null = null,
): [boolean, (text: CopyableValue) => void] => {
    const [isCopied, setCopied] = useState(false);

    const handleCopy = useCallback((text: CopyableValue) => {
        if (typeof text === 'string' || typeof text === 'number') {
            copy(text.toString());
            setCopied(true);
        } else {
            setCopied(false);
            console.error(
                `Cannot copy typeof ${typeof text} to clipboard, must be a string or number.`,
            );
        }
    }, []);

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout> | undefined;
        if (isCopied && resetInterval) {
            timeout = setTimeout(() => setCopied(false), resetInterval);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isCopied, resetInterval]);

    return [isCopied, handleCopy];
};

export default useCopyToClipboard;
